export default __webpack_public_path__ + "assets/images/5152c9c906cf7384a480fec6469b7093.png";